<template>
  <News code="committee_work" />
</template>
<script>
import News from "./news.vue";

export default {
  name: "committee_work",
  components: {
    News,
  },
  data() {
    return {
      pageData: {},
    };
  },
  created() {},
  methods: {},
};
</script>
